import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=3af3070c&scoped=true"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProfileAvatar.vue?vue&type=style&index=0&id=3af3070c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af3070c",
  null
  
)

export default component.exports